import { Manufacturer } from 'models/Manufacturer';
import { Unit } from 'models/Unit';

export class MachinePart {
    id: number;
    name: string;
    manufacturer: Manufacturer | null;
    manufacturerPartNumber: string | null;
    ean: string | null;
    price: number | null;
    unit: Unit | null;
    archivedDate?: Date;

    constructor(
        id: number,
        name: string,
        manufacturer: Manufacturer | null,
        manufacturerPartNumber: string | null,
        ean: string | null,
        price: number | null,
        unit: Unit | null,
        archivedDate?: Date
    ) {
        this.id = id;
        this.name = name;
        this.manufacturer = manufacturer;
        this.manufacturerPartNumber = manufacturerPartNumber;
        this.ean = ean;
        this.price = price;
        this.unit = unit;
        this.archivedDate = archivedDate;
    }

    // also the form template: gives the input type of fields that come back null
    static empty(): MachinePart {
        return { id: 0, name: '', manufacturer: Manufacturer.empty(), manufacturerPartNumber: '', ean: '', price: NaN, unit: Unit.empty() };
    }
}
